console.log(process.env)
const isDev = process.env.NODE_ENV === "development"
export const apiUri = isDev ? "http://localhost:3001/graphql" :  
                      "https://uzsza9dy68.execute-api.eu-north-1.amazonaws.com/dev/graphql"